import UnwrappedDropdown from './UnwrappedDropdown';
import OnClickOutside from 'react-onclickoutside';

// Wrap component in Higher Order OnClickOutside Component for handling
// when user clicks off of dropdown
export default OnClickOutside(UnwrappedDropdown);
